export class DatabaseUserGroupAttribute {
    id = 0;
    key = "";
    value = "";
}
